<div class="challenges-admin-container" [ngClass]="isCxone ? 'cxone-container' : 'container'">
    <div class="challenges-header-container row" [ngClass]="{'mt-3 m-2': !isCxone, 'header-container': isCxone}" [hidden]="cs.currentView != 0">        
        <div class="challenges-buttons col-12 col-md-12 d-flex" [ngClass]="{'buttons': isCxone}">
            <div class="col-7" [hidden]="!isCxone" [ngClass]="{'buttons': isCxone}">
                <h6 cvLocalizedText langSection="Challenges" langKey="Running_Challenges" class="challenges-title-text" [ngClass]="{'mb-0': isCxone}">Running Challenges</h6>
            </div>
            <button type="button" class="btn btn-text btn-icon fill-cerulean ml-auto" (click)="showHistory()" [hidden]="isCxone">
                <svg><use href="../App_Themes/clearview-default/icons/utility/history.svg#history"></use></svg>
                <span cvLocalizedText langSection="Challenges" langKey="View_History">View History</span>
            </button>
            
            <button type="button" class="btn btn-text btn-icon fill-cerulean ml-3" (click)="showSettings()" [hidden]="isCxone">
                <svg><use href="../App_Themes/clearview-default/icons/utility/settings.svg#settings"></use></svg>
                <span cvLocalizedText langSection="Common" langKey="Settings">Settings</span>
            </button>
            <sol-button [variant]="'basic'"
                [size]="'large'"
                [matMenuTriggerFor]="menu.menu"
                [hidden]="!isCxone"
                class="ml-auto">
                <span cvLocalizedText langSection="Module_Menu" langKey="Export" class="line-height-buttom">Export</span>
            </sol-button>

            <sol-floating-menu #menu
                menuClass="export-menu-challenge"
                [menuItems]="defaultMenuOptions"
                [spriteIconPath]="'../App_Themes/CXone/icons/export-menu-icons.svg'"
                position="'bottom'">
            </sol-floating-menu>
            <sol-button [variant]="'basic'"
                        [disabled]="!hasPermission('CREATE') && !hasPermission('WRITE')"
                        [size]="'large'"
                        (click)="hasPermission('CREATE') || hasPermission('WRITE') ? showSettings() : ''" [hidden]="!isCxone"
                        class="ml-3">
                <span cvLocalizedText langSection="Common" langKey="Settings" class="line-height-buttom">Settings</span>
            </sol-button>
        </div>
    </div>

    <cv-challenges-history *ngIf="historyHasBeenOpened" [hidden]="cs.currentView != 1"></cv-challenges-history>
    <cv-challenges-settings *ngIf="settingsHasBeenOpened" [hidden]="cs.currentView != 2" ></cv-challenges-settings>

    <div class="content mx-auto" [hidden]="cs.currentView != 0" [ngClass]="isCxone ? 'challenges-container ' + (cs?.runningChallenges?.length == 0 ? 'ag-theme-balham-class' : '') : 'p-2 mt-3 cv-challenge-container'">
        <div class="challengeHistoryList mx-auto" [ngClass]="{'counter-container challenge-list mt-0': isCxone}">
            <div class="row" [ngClass]="isCxone ? 'header-container omnibar-container mx-0' : 'mb-3'">
                <div class="col-7" [hidden]="isCxone">
                    <h8 cvLocalizedText langSection="Challenges" langKey="Running_Challenges">Running Challenges</h8>
                </div>
                <sol-omnibar
                    *ngIf="isCxone"
                    [isFilterable]="false"
                    [itemCountLabel]="getCombinedLabel()"
                    [searchPlaceholderText]="getLocalizedMessage('Search_Challenge', 'Search challenge')"
                    (searchQueryChange)="search = $event; filterChanged()"
                    [searchQuery]="search"
                ></sol-omnibar>

                <div class="col-5" style="display:flex;" [hidden]="isCxone">
                    <cv-generic-export [items]="items" [fileName]="getLocalizedMessage('Running_Challenges', 'Running Challenges')"></cv-generic-export>
                    <div class="search-box live-search">
                        <input type="search" class="form-control" name="CustomFilter" [(ngModel)]="search" (ngModelChange)="filterChanged()" cvLocalizedPlaceholder langSection="Users" langKey="Search" autocomplete="off" maxlength="40" />
                        <span class="clear-input" [hidden]="search.length == 0" (click)="clearFilter()"></span>
                    </div>
                </div>
            </div>

            <div class="performanceContent w-100 mx-auto" [hidden]="isLoading">
                <div class="challengesManagement">
                    <ag-grid-angular #challengesListGrid *ngIf="challengesGrid" class="performanceTable ag-theme-balham flex-fill" [gridOptions]="challengesGrid" [ngClass]="isCxone ? 'ag-theme-cv-challenges' : 'challenges-list-grid'"></ag-grid-angular>
                </div>
            </div>
        </div>

        <div *ngIf="isCxone" [hidden]="!(!isLoading && getRowCount() == 0 && search !== '')" class="cxone-empty-state" id="noResultsState">
            <svg class="cxone-favorite-state">
                <use href="../App_Themes/CXone/icons/no-results-big.svg#no-results-big"></use>
            </svg>
            <p class="cxone-empty-text" cvLocalizedText langSection="Challenges" langKey="No_Results">No results found</p>
        </div>

        <div *ngIf="isCxone" [hidden]="!(!isLoading && cs?.runningChallenges?.length == 0 && search === '')" class="cxone-empty-state" id="noChallengesState">
            <svg class="cxone-favorite-state">
                <use href="../App_Themes/CXone/icons/cxone-no-items.svg#cxone-no-items"></use>
            </svg>
            <p class="cxone-empty-text" cvLocalizedText langSection="Error_Module" langKey="No_Challenges_Created_Yet">No challenges created yet</p>
        </div>

        <div class="loadView w-100" style="height: 30vh" [hidden]="!isLoading || isCxone"></div>
        <cv-loader [loaderType]="'cxone'" [size]="'large'" [overlay]="false" [hidden]="!isLoading || !isCxone"></cv-loader>
    </div>
</div>
